import ACTION_ITEMS from '../actionItems';

export function setSelectedCandidate(candidate) {
  return {
    type: ACTION_ITEMS.PROJECT_BUILDER.SELECTED_CANDIDATE.SET,
    payload: candidate,
  };
}
